<template>
  <b-modal
    id="transferData"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    :visible="showTransferModal"
    @hidden="$emit('close-transfer-modal')"
  >
    <main>
      <header>
        <div
          class="d-flex align-items-center justify-content-between px-4 py-3"
        >
          <div class="b-modal-header">Transfer Position ID</div>
          <div @click="$emit('close-transfer-modal')" class="rotate-on-hover">
            <img
              src="../../../assets/panelist/blue_cross.svg"
              alt=""
              class="pointer rotate-on-hover"
            />
          </div>
        </div>
        <hr class="m-0" />
        <body class="px-4 py-3">
          <section class="d-flex align-items-center">
            <img src="../../../assets/img/info-icon.svg" class="mr-2" alt="" />
            <div class="info-font-text-1 ml-2">
              You are changing the recruiter for the position ID
              <br />
              <strong style="color: #20639b"> "{{ positionID }}" </strong>
            </div>
          </section>

          <section class="info-text-subhead mt-3">
            Please choose appropriate option:
          </section>
          <section>
            <b-form-group>
              <div class="mt-3">
                <b-form-radio
                  v-model="tranferID"
                  value="1"
                  class="manage-radio-main"
                  >Transfer only Position ID</b-form-radio
                >
              </div>
              <div class="mt-3">
                <b-form-radio
                  v-model="tranferID"
                  class="manage-radio-main"
                  value="2"
                  >Transfer Position ID along with its candidates</b-form-radio
                >
              </div>
            </b-form-group>
          </section>
        </body>
        <hr class="m-0" />
        <footer
          class="p-3 d-flex align-items-center w-100 justify-content-between"
        >
          <section class="d-flex align-items-center ml-2">
            <div class="common-single-checkbox">
              <b-form-checkbox v-model="minutes"> </b-form-checkbox>
            </div>
            <div class="info-checkbox-text">Don't ask for next 5 Minutes</div>
          </section>
          <section class="bluebtn d-flex align-items-center">
            <b-button
              @click="$emit('close-transfer-modal')"
              class="acs-cancelBtn-modal mr-3"
              >Cancel</b-button
            >
            <div class="addpanellog position-relative">
              <b-button
                class="acs-addBtn-modal pl-4 pr-4"
                @click="
                  buttonLoader
                    ? ''
                    : $emit('reassign-possition-id', tranferID, minutes)
                "
                :class="buttonLoader ? 'givefeed-loader-class' : 'pointer'"
              >
                <span v-if="!buttonLoader"> Continue </span>
              </b-button>

              <div v-if="buttonLoader" class="loader-pos">
                <Loader />
              </div>
            </div>
          </section>
        </footer>
      </header>
    </main>
  </b-modal>
</template>

<script>
import Loader from "../../../components/fixedcomponents/Loader.vue";
export default {
  name: "TranferPositionID",
  props: {
    showTransferModal: Boolean,
    buttonLoader: Boolean,
    positionID: String,
  },
  components: {
    Loader,
  },
  data() {
    return {
      tranferID: "1",
      minutes: false,
    };
  },
};
</script>
<style scoped>
.loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -2px;
}
.givefeed-loader-class {
  opacity: 0.5;
  height: 32px;
  width: 95px;
}
</style>
